import React, { useState,useEffect } from 'react';
import api from "../../../../../api";
import {
  Dropdown,
  Form,
  Loader
} from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import './parseData.css';
import './KeyPadRule.css';
const digitOptions = Array.from({ length: 10 }, (_, i) => ({
  key: i,
  value: i,
  text: i.toString(),
}));

const KeyPadRule = ({ turboList,keypadrule ,workspace_id,popupClose,countryCodeLists,defaultCountryCodeLists,branch_id,bot_type}) => {
   // Dynamically set transfer type options
    const transferTypeOptions =
        bot_type === 'OUTBOUND'
            ? [{ key: 'forward', value: 'Forward', text: 'Forward' }]
            : [
                { key: 'forward', value: 'Forward', text: 'Forward' },
                { key: 'assistant', value: 'Assistant', text: 'Assistant' },
            ];

    let prevrules;
    try{
        prevrules = JSON.parse(keypadrule);
        console.log(prevrules,"keypadrule");
    }catch($e){
        prevrules = [];
    }
    const [rules, setRules] = useState([]);
    const [showNotification,setShowNotification]=useState(false);   
    const [notification,setNotification]=useState(''); 
    const [notificationtype,setNotificationtype]=useState('success'); 
    const [assistantOptions,setAssistantOptions]=useState([]); 
    const [callforwards,setCallforwards]=useState([]); 
    const [loading,setloading]=useState(false);
    const [errors,setErrors]=useState([]);
    const [errorMessage,setErrorMessage]=useState('');
    // Track if rules changed — show submit button accordingly
    // const assistantOptions = turboList.map(assistant => ({
    //     key: assistant.wid,
    //     value: assistant.name,
    //     text: assistant.name,
    // }));
    
    const addRule = () => {
        setRules([
        ...rules,
        {
            id: Date.now(),
            digit: null,
            transferType: '',
            assistant: '',
            editable: true,
            assistant_id:'',
            call_forward:'',
        },
        ]);
    };
     useEffect(() => {
       onload();
     },[workspace_id]);

     const onload = () => {
        setloading(true);
        getactiveAssistant();
        getCallforwards();  
         
             api.botbuilder.getKeyPadRules({workspace_id:workspace_id,branch_id}).then( res => {
                 setloading(false);
                 if(res.status && res.rules.length > 0){
                     let reslist=res.rules;
                     if(reslist){
                        reslist=reslist.map((rul,i)=>{
                            console.log(i);
                             rul.editable=true;
                             rul.id=crypto.randomUUID();
                             return rul;   
                        })
                     }
                     setRules(reslist);
                 }else{
                    let new_rule=[{
                        id: crypto.randomUUID(),
                        digit: null,
                        transferType: '',
                        assistant: '',
                        editable: true,
                        assistant_id:'',
                        call_forward:'',
                    }];
                    setRules(new_rule);
                 }
             }
             )
             .catch((err) => {
                 setloading(false);
                 console.log(err)
             })
         }

         const getactiveAssistant=()=>{
            api.botbuilder.getactiveAssistants({workspace_id:workspace_id,branch_id}).then( res => {
                            let  ws_list=[];
                            if(res.data.list.length > 0){
                            ws_list= res.data.list.map(assistant => ({
                                    key: assistant.auto_id,
                                    value: assistant.name,
                                    text: assistant.name,
                                }));
                                setAssistantOptions(ws_list);
                            }
                        }
                        )
                        .catch((err) => {
                            setloading(false);
                            console.log(err)
                        });
         }
         const getCallforwards=()=>{
            api.botbuilder.getcallforwarding({'workspace_id': workspace_id,branch_id }).then(data => {
                        try {
                            if (data.data.length && data.status) {
                                let res=data.data;
                                res=res.map((rule)=>({
                                        key:rule.id,
                                        value:rule.id,
                                        text:rule.forward_name
                                }));
                            setCallforwards(res);
                            
                        }
            
                        }catch (err) {
                            console.log(err);
                            }
                        });
         
        }

    const getErrorMessage = (errors) => {
        let hasRequired = false;
        let hasDuplicate = false;
        
        errors.forEach(error => {
            Object.values(error.errors).forEach(errorMessage => {
                if (errorMessage === 'This field is required.') {
                    hasRequired = true;
                }
                if (errorMessage.includes('Duplicate') || errorMessage.includes('already exists')) {
                    hasDuplicate = true;
                }
            });
        });
        
        if (hasRequired && hasDuplicate) {
            return "Fill in all the required the fields and remove duplicate entries.";
        } else if (hasRequired) {
            return "Fill in all the required fields.";
        } else if (hasDuplicate) {
            return "Remove duplicate entries.";
        }
        return "Fix the errors in the form above.";
    };

    const validatePhoneEntries = (entries) => {
        const errors = [];
        let prevrules = rules;

        // Track duplicates
        const digitCount = {};
        const assistantTransferCount = {};
        const callForwardCount = {};

        entries.forEach((entry) => {
            const { digit, transferType, assistant, call_forward } = entry;
            // Count digits
            if (digit !== null && digit !== '' && typeof digit !== 'undefined') {
                digitCount[digit] = (digitCount[digit] || 0) + 1;
            }
            // Count assistant transfers
            if (transferType === 'Assistant' && assistant) {
                const key = `${assistant}`;
                assistantTransferCount[key] = (assistantTransferCount[key] || 0) + 1;
            }
            // Count call forwards
            if (transferType === 'Forward' && call_forward) {
                const key = `${call_forward}`;
                callForwardCount[key] = (callForwardCount[key] || 0) + 1;
            }
        });
console.log(assistantTransferCount,'asistantTransferCount');
        entries.forEach((entry) => {
            const { assistant, transferType, id, digit, call_forward } = entry;
            const entryErrors = {};

            if (digit === null || digit === '' || typeof digit === 'undefined') {
                entryErrors.digit = 'This field is required.';
            }
            if (transferType == '') {
                entryErrors.transferType = 'This field is required.';
            }
            if (transferType == 'Forward' && (!call_forward || call_forward.trim() === '')) {
                entryErrors.call_forward = 'This field is required.';
            }
            if (transferType == 'Assistant' && (!assistant || assistant.trim() === '')) {
                entryErrors.assistant = 'This field is required.';
            }

            // Duplicate digit
            if (digit !== null && digit !== '' && typeof digit !== 'undefined' && digitCount[digit] > 1) {
                entryErrors.digit = 'Duplicate digit is not allowed.';
            }
            // Duplicate assistant transfer for same digit
            if (
                transferType === 'Assistant' &&
                assistant &&
                assistantTransferCount[`${assistant}`] > 1
            ) {
                entryErrors.assistant = 'Duplicate assistant  is not allowed.';
            }
            // Duplicate call forward for same digit
            if (
                transferType === 'Forward' &&
                call_forward &&
                callForwardCount[`${call_forward}`] > 1
            ) {
                entryErrors.call_forward = 'Duplicate call forward  is not allowed.';
            }

            if (Object.keys(entryErrors).length > 0) {
                prevrules = prevrules.map(prevrule => {
                    if (prevrule.id === id) prevrule.editable = true;
                    return prevrule;
                });
                errors.push({ id, errors: entryErrors });
            }
        });
        setRules(prevrules);
        return errors;
    };

         
    // Submit handler
    const handleSubmit = () => {
        let prevrules=rules;
         let errors=validatePhoneEntries(prevrules);
         if(errors.length>0){
            const errorMessage = getErrorMessage(errors);
            setErrors(errors);
            setErrorMessage(errorMessage);
            return false;
         }else{
             setErrors([]);
             setErrorMessage('');
         }
          setloading(true);
        // Prepare JSON — filter only relevant data (digit, transferType, assistant)
        const output = rules.map(({ id, editable, ...rest }) => rest);
        api.botbuilder.updatekeypressrule({rule:output,workspace_id:workspace_id,branch_id}).then((data) => {
            try {
                console.log('apiss',data);
              if(data.status){
                //    let rules_arr=rules;
                //    rules_arr=rules_arr.map((itm)=>{
                //        itm.editable=false;
                //        return itm;
                //    });
                //    setRules(rules_arr);
                   setShowNotification(true);
                   setNotification('Rules saved successfully.')  
                   setNotificationtype('success'); 
              }else{
                   setShowNotification(true);
                   setNotification('An error occured.')  
                   setNotificationtype('error'); 
              }
                setloading(false);
              setTimeout(() => {
                 setShowNotification(false);
                setNotification('')  
                setNotificationtype('success'); 
              }, 4000);
            
            } catch (err) {
                  setloading(false);
                 setShowNotification(false);
                setNotification(false);
                console.log(err);        
            }
        });
    };
    
    

    const deleteRule = (id) => {
        let nowrules = rules.filter(rule => rule.id !== id)
        setRules(nowrules);
        
    };

    const toggleEdit = (id) => {
        setRules(prev =>
        prev.map(rule =>
            rule.id === id ? { ...rule, editable: !rule.editable } : rule
        )
        );
    };

    const updateRule = (id, field, value) => {
        console.log(value,field,id,assistantOptions);
          let errs=errors.filter(er=>er.id!=id);
          setErrors(errs);
        const selectedAssistant1 = assistantOptions.find(asst => asst.text === value);
    setRules(prev =>
        prev.map(rule => {
            if (rule.id === id) {
                const updatedRule = { ...rule, [field]: value };

                if (field === 'assistant') {
                    // Find the assistant_id directly if 'assistant' field is being updated
                    const selectedAssistant = assistantOptions.find(asst => asst.text === value);
                    console.log(value,'value',selectedAssistant);
                    if (selectedAssistant) { // Ensure an assistant is found
                        updatedRule.assistant_id = selectedAssistant.key;
                    } else {
                        // Handle case where assistant is not found, e.g., set to null or log a warning
                        updatedRule.assistant_id = null; // Or some default/error state
                       
                    }
                }else if(field === 'transferType' && value=='Forward'){
                     updatedRule.assistant_id = null;
                }
                return updatedRule;
            }
            return rule; // Return rule unchanged if ID doesn't match
        })
    );
}
const phoneFormat = (p) => {
        p = p.replace(/[^\d]*/gi, "");
        if (p.length <= 3) {
            return p;
        } else if (p.length > 3 && p.length < 7) {
            p = "(" + p;
            let l30 = p.length;
            let p30 = p.substring(0, 4);
            p30 = p30 + ")";

            let p31 = p.substring(4, l30);
            let pp = p30 + p31;
            return pp;
        } else if (p.length >= 7) {
            p = "(" + p;
            let l30 = p.length;
            let p30 = p.substring(0, 4);
            p30 = p30 + ")";

            let p31 = p.substring(4, l30);
            let pp = p30 + p31;

            let l40 = pp.length;
            let p40 = pp.substring(0, 8);
            p40 = p40 + "-";

            let p41 = pp.substring(8, l40);
            let ppp = p40 + p41;
            let maxphonelength = 13;
            let finalPhone = ppp.substring(0, maxphonelength);
            return finalPhone;
        }
    };
    
    
    const selectedTransferTypes = rules.map(r => r.transferType).filter(Boolean);
    const selectedDigits = rules.map(rule => rule.digit).filter(d => d !== null && d !== undefined);
    const selectedAssistants = rules
        .filter(rule => rule.transferType === 'Assistant')
        .map(rule => rule.assistant)
        .filter(Boolean);
    const selectCalls=rules.filter(rule=>rule.transferType=='Forward').map(rule=>rule.call_forward).filter(Boolean);

    return (
        <>
            <div className="parsescreen" id='keypadsettings'>
                <div className="yr-chat-round-box yr-closebtn">
                   
                    <button
                        type="button"
                        class="close linear-gradient"
                         onClick={() => popupClose()}
                        style={{color:'#000 !important'}}
                    >
                        &#10006;
                    </button>
                     <div className="box-title"> Add Keypad Rule
  <button type="button" title=" Add Keypad Rule." className="btn btn-sm btn-clean btn-icon" onClick={(e) => addRule()}>
                            <img src="../../assets/media/icons/plus.svg" alt="" width={15} />
                        </button>

                     </div>
        {showNotification && <div className={`ui message ${notificationtype === "success" ? "green" : "red"}`} >{notification}</div>}
        {errorMessage && <div className="ui red message" style={{marginTop:'10px'}}>{errorMessage}</div>}
        {loading &&  <Loader active>Loading</Loader>}
        <Form style={{overflowX:rules.length>0 ? 'auto':'hidden',paddingBottom: '30px',scrollbarWidth: 'thin'}}>
            {rules.map((rule, index) => {
                let err=errors.filter(er=>er.id==rule.id);
               
                return(
            <Form.Group key={rule.id} widths="equal" style={{ alignItems: 'start',width:'98%'}}>
                <Form.Field style={{width:"100px",maxWidth:'100px'}} className={err && err[0]?.errors?.digit ? 'dropdown-error' : ''}>
                <label>Digits</label>
                <Dropdown
                    placeholder="Select"
                    fluid
                    selection
                    disabled={!rule.editable}
                    options={digitOptions.map(opt => ({
                    ...opt,
                    disabled:
                        selectedDigits.includes(opt.value) &&
                        rule.digit !== opt.value,
                    }))}
                    value={rule.digit}
                    onChange={(_, { value }) =>
                    updateRule(rule.id, 'digit', value)
                    }
                />
                </Form.Field>

                <Form.Field style={{width:"120px",maxWidth:"120px"}} className={err && err[0]?.errors?.transferType ? 'dropdown-error' : ''}>
                <label>Transfer Types</label>
                <Dropdown
                    placeholder="Select"
                    fluid
                    selection
                    disabled={!rule.editable}
                    options={transferTypeOptions.map(opt => ({
                    ...opt
                    }))}
                    value={rule.transferType}
                    onChange={(_, { value }) =>
                    updateRule(rule.id, 'transferType', value)
                    }
                />
                </Form.Field>

                {rule.transferType === 'Assistant' && (
                <Form.Field style={{minWidth:"180px" ,maxWidth:'200px',width:'auto' }} className={err && err[0]?.errors?.assistant ? 'dropdown-error' : ''}>
                    <label>Assistants</label>
                    <Dropdown
                    placeholder="Select"
                    fluid
                    selection
                    disabled={!rule.editable}
                    options={assistantOptions.map(opt => ({
                        ...opt,
                        disabled:
                        selectedAssistants.includes(opt.value) &&
                        rule.assistant !== opt.value,
                    }))}
                    value={rule.assistant}
                    onChange={(_, { value }) =>
                        updateRule(rule.id, 'assistant', value)
                    }
                    />
                </Form.Field>
                )}
                {rule.transferType === 'Forward' && (
                 <Form.Field style={{minWidth:"180px" ,maxWidth:'200px',width:'auto'}} className={err && err[0]?.errors?.call_forward ? 'dropdown-error' : ''}>
                    <label>Call Forwards</label>
                    <Dropdown
                    placeholder="Select"
                    fluid
                    selection
                    disabled={!rule.editable}
                    options={callforwards.map(opt => ({
                        ...opt,
                        disabled:
                        selectCalls.includes(opt.value) &&
                        rule.call_forward !== opt.value,
                    }))}
                    value={rule.call_forward}
                    onChange={(_, { value }) =>
                        updateRule(rule.id, 'call_forward', value)
                    }
                    />
                </Form.Field>
                )}
              
                <div style={{ marginTop: '38px',display:'flex'}}>
                  
                     <span  style={{
                        display: 'inline-flex',
                        cursor: 'pointer',
                        color:"red",
                        fontSize:"20px"
                        }}
                        onClick={() => deleteRule(rule.id)}
                        title="Delete">
                       <i style={{fontSize:"14px"}} class="la la-trash red" title="Delete"></i>
                    </span>
                </div>

               
            </Form.Group>
            )
        }
            )}

            
            {/* Show submit button only if changes exist */}
         
             <div className="row" id="endrow">
                        <div className="col-12 d-flex justify-content-end">
                            <button
                            type="reset"
                            class="btn yr-cancelbtn linear-gradient-cancel mg-r"
                            onClick={() => popupClose()}
                            >
                        <span> Close </span>
                            </button>
                             <button
                            type="submit"
                            className="btn linear-gradient yr-submitbtn"
                            onClick={handleSubmit}
                            >
                                Save
                            </button>
                        </div>
                    </div>
        </Form>
        </div>
        </div>
       </>
    );
};

export default KeyPadRule;
